import { render, staticRenderFns } from "./TeacherMyCourses.vue?vue&type=template&id=ae2cbd32&scoped=true&"
import script from "./TeacherMyCourses.vue?vue&type=script&lang=js&"
export * from "./TeacherMyCourses.vue?vue&type=script&lang=js&"
import style0 from "./TeacherMyCourses.vue?vue&type=style&index=0&id=ae2cbd32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2cbd32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VContainer,VDivider,VForm,VRow,VTextField,VTextarea})
